
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.028 0H1.972C1.44 0 .97.203.563.61.188.986 0 1.44 0 1.972V20l3.99-3.99h14.038c.532 0 .986-.188 1.362-.564.407-.407.61-.892.61-1.455V1.97c0-.531-.203-.985-.61-1.36C19.014.202 18.56 0 18.028 0zM11.55 9.577L10 13.005 8.45 9.577 4.978 7.981l3.474-1.55L10 3.006l1.55 3.427 3.473 1.55-3.474 1.595z","fill":"#fff"}})])
          )
        }
      }
    